module.exports = {"440523100":"后宅镇","440523101":"云澳镇","440523102":"深澳镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440523.json
// module id = 2110
// module chunks = 0